import { useColorModeValue } from '@chakra-ui/react';
import { Panel } from '@gamma/ui/layout';
import { ErrorMessage, GraphQLReqStatus } from '@gamma/ui/progress';
import { graphqlErrorRedirects } from '../../../../shared/constants';
import { i18n } from '../../../../shared/localization';
import { IGetDetectionPeriodSummary } from '../../../detections/queries';

import { useUserSession } from '../../../../shared/hooks';
import { StatisticPanel } from '../StatisticPanel';

interface EntitiesWithDetectionsPanelProps {
  data?: IGetDetectionPeriodSummary;
  loading: boolean;
  error?: ErrorMessage;
}

export const EntitiesWithDetectionsPanel = ({
  data,
  loading,
  error,
}: EntitiesWithDetectionsPanelProps) => {
  const { signOut } = useUserSession();

  const iconBgColor = useColorModeValue('red.300', 'red.700');

  const { current, previous, pct_chg } =
    data?.getDetectionPeriodSummary?.total_entities || {};

  const { heading } = i18n.pages.securityOverview.panels.entitiesWithDetections;

  if (loading || error) {
    return (
      <Panel>
        <GraphQLReqStatus
          loading={loading}
          error={error}
          signOut={signOut}
          extended={graphqlErrorRedirects}
        />
      </Panel>
    );
  }

  return (
    <StatisticPanel
      iconBgColor={iconBgColor}
      heading={heading}
      current={current}
      previous={previous}
      pct_chg={pct_chg}
      infoLabelTestId="entities-with-detections-info-label"
    />
  );
};
